import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKey16 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3509_12938)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M8.98999 8.79962C9.99999 9.04962 11 8.83962 11.8 8.17962C13.16 7.04962 13.32 4.91962 12.1 3.62962C10.88 2.33962 8.86999 2.27962 7.59999 3.54962C6.90999 4.23962 6.62999 5.20962 6.69999 6.09962L6.48999 6.30962L2.98999 9.98962V12.9896H5.98999V10.9896H7.98999V8.98962L8.98999 8.79962Z",
			stroke: "white",
			strokeWidth: 2,
			strokeLinejoin: "bevel"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M9.75 6.5C10.1642 6.5 10.5 6.16421 10.5 5.75C10.5 5.33579 10.1642 5 9.75 5C9.33579 5 9 5.33579 9 5.75C9 6.16421 9.33579 6.5 9.75 6.5Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3509_12938",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgKey16;
